import React from 'react';
import './main.css';

import step1 from "../images/step1-wd3.svg";
import step2 from "../images/Step2.svg";
import step3 from "../images/step3-wd4.svg";
import { Typography } from "@material-ui/core";

function Title(props) {
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        const graphic = new Image();
        graphic.src = props.img;
        graphic.onload = () => {
            setLoaded(true);
        };
    });

    if (loaded) {
        return (
            <div className="title-section-app">
                <Typography className="title-section__title-app" variant="h4">{props.title}</Typography>
                <div className="title-section__graphic-app">
                    <img src={props.img} className="title-section__graphic__background-app" alt="sap" />
                    <div>
                        <div className="title-section__graphic__step1-app">
                            <img src={step1} alt="step1" />
                            <Typography variant="h5" className="title-section__graphic__step1__title-app">Step 1</Typography>
                        </div>
                        <div className="title-section__graphic__step2-app">
                            <img src={step2} alt="step2" />
                            <Typography variant="h5" className="title-section__graphic__step2__title-app">Step 2</Typography>
                        </div>
                        <div className="title-section__graphic__step3-app">
                            <img src={step3} alt="step3" />
                            <Typography variant="h5" className="title-section__graphic__step3__title-app">Step 3</Typography>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="title-section--loading">
            </div>
        );
    }
}

export default Title;